/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Intro_P2Inputs */

const en_pc_alt_intro_p2 = /** @type {(inputs: Pc_Alt_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page compares PdfCraft with the tools people most often weigh it against. We are an independent guide with no commercial relationship with any of these vendors, and none of the links below are affiliate links.`)
};

const zh_pc_alt_intro_p2 = /** @type {(inputs: Pc_Alt_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本页把 PdfCraft 与人们最常拿来比较的工具放在一起对比。我们是独立指南站，与这些厂商都没有商业关系，下面的链接也都不是推广链接。`)
};

/**
* | output |
* | --- |
* | "This page compares PdfCraft with the tools people most often weigh it against. We are an independent guide with no commercial relationship with any of these ..." |
*
* @param {Pc_Alt_Intro_P2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_intro_p2 = /** @type {((inputs?: Pc_Alt_Intro_P2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Intro_P2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_intro_p2(inputs)
	return zh_pc_alt_intro_p2(inputs)
});
export { pc_alt_intro_p2 as "pc.alt.intro_p2" }